import axios from "axios";

const scheduleUrl = "/v2/api/schedule";
const equipmentUrl = "/v2/api/equipment";
const serviceUrl = "/v2/api/equipment/service/upcoming-services";


class EquipmentScheduleService {

    // ── Schedule CRUD ──

    static createSchedule(payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = scheduleUrl;
                const result = await axios.post(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getSchedules(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [scheduleUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getScheduleById(scheduleId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}`;
                const result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getScheduleByJobId(jobId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/job/${jobId}`;
                const result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateSchedule(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}`;
                const result = await axios.put(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // ── Schedule Operations ──

    static updateScheduleEquipment(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/equipment`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateScheduleDates(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/dates`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static confirmSchedule(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/confirm`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static cancelSchedule(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/cancel`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getScheduleSummary(scheduleId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/summary`;
                const result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static patchScheduleCompletion(scheduleId, completionData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/completion`;
                await axios.patch(url, completionData);
                resolve(`Schedule record with ID ${scheduleId} completion updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // ── Assignments ──

    static addAssignments(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/assignments`;
                const result = await axios.post(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static listAssignments(scheduleId, urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${scheduleUrl}/${scheduleId}/assignments`;
                if (urlP) url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateAssignment(assignmentId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/assignments/${assignmentId}`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateAssignmentStatus(assignmentId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/assignments/${assignmentId}/status`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static cancelAssignment(assignmentId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/assignments/${assignmentId}/cancel`;
                const result = await axios.patch(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static cancelAssignmentsByEngineer(scheduleId, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/${scheduleId}/assignments/cancel-by-engineer`;
                const result = await axios.patch(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // ── Calendar / Planning Views ──

    static checkClashes(payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${scheduleUrl}/clashes`;
                const result = await axios.post(url, payload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getCalendar(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${scheduleUrl}/calendar`;
                if (urlP) url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getMySchedule(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${scheduleUrl}/my-schedule`;
                if (urlP) url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // ── Equipment Queries (existing) ──

    static searchEquipmentUpComingService(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [serviceUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static searchAllSchedules(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [scheduleUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static searchAllMySchedules(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${scheduleUrl}/my-schedule`;
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getEquipmentsByCustomerId(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [equipmentUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getEquipmentsAndScheduleByCustomerId(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [scheduleUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    // ── Documents ──

    static uploadDocuments(files, scheduleId) {
        return new Promise(async (resolve, reject) => {
            try {
                const filesToUpload = files.map((file) => ({
                    filename: file.name,
                    content_type: file.content_type,
                    visibility: "Internal",
                    category: "schedules",
                    name: file.name,
                    unique_id: file.unique_id,
                    requires_thumbnail: (file.requires_thumbnail !== undefined) ? file.requires_thumbnail : false,
                    document_role: (file.document_role !== undefined) ? file.document_role : 'attachment',
                }));

                const scheduleDocumentUrl = `${scheduleUrl}/${scheduleId}/documents`;

                let result = await axios.post(scheduleDocumentUrl, filesToUpload);
                resolve(result.data);
            } catch (error) {
                console.error("Error uploading documents:", error);
                reject(error.response);
            }
        });
    }

    static async getScheduleDocuments(scheduleId, documentRole) {
        try {
            const scheduleDocumentUrl = `${scheduleUrl}/${scheduleId}/documents`;
            const scheduleDocumentUrlWithRole = documentRole
                ? `${scheduleDocumentUrl}?document_role=${encodeURIComponent(documentRole)}`
                : scheduleDocumentUrl;

            let result = await axios.get(scheduleDocumentUrlWithRole);
            return result.data;
        } catch (error) {
            console.error("Error fetching schedule documents:", error);
            throw error;
        }
    }

    static async deleteScheduleDocuments(scheduleId, documentIds) {
        try {
            const scheduleDocumentUrl = `${scheduleUrl}/${scheduleId}/documents`;

            await axios.delete(scheduleDocumentUrl, {
                data: documentIds,
                headers: { "Content-Type": "application/json" },
            });
        } catch (error) {
            console.error("Error deleting schedule documents:", error);
            throw error;
        }
    }
}

export default EquipmentScheduleService;
